import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "group"]

  connect() {
    this.toggle()
  }

  toggle() {
    const channel = this.selectTarget.value
    this.groupTargets.forEach((group) => {
      group.hidden = !group.dataset.channels.split(" ").includes(channel)
    })
  }
}
